<!--
 * @Author: your name
 * @Date: 2022-03-08 12:04:22
 * @LastEditors: onepisYa
 * @LastEditTime: 2022-03-23 12:09:46
 * @Description: file content

-->
<template>
  <div>
    <LuckyWheel
      :blocks="blocks"
      :buttons="buttons"
      :prizes="prizes"
      @end="endCallback"
      @start="startCallback"
      height="75vw"
      ref="myLucky"
      width="75vw"
    />
  </div>
</template>

<script>
  export default {
    props: { prizes: { type: Array, required: true } },
    data() {
      return {
        blocks: [
          {
            padding: "2rem",
            imgs: [
              {
                src: require("../../../assets/lottery/tablePlate.jpg"),
                rotate: true,
                width: "75vw",
                height: "75vw",
              },
            ],
          },
        ],
        buttons: [
          { radius: "50px", background: "#ff7726" },
          { radius: "45px", background: "#ffefc1" },
          {
            fonts: [{ text: "", top: "-20px", fontColor: "#FFFFFF" }],
            imgs: [
              {
                src: require("../../../assets/lottery/pointer.png"),
                top: "-75",
              },
            ],
          },
        ],
      };
    },
    methods: {
      // 点击抽奖按钮会触发star回调
      startCallback() {
        this.$emit("start", this.$refs.myLucky);
      },
      // 抽奖结束会触发end回调
      endCallback(prize) {
        // 将奖品对象传递出去。
        this.$emit("end", prize);
      },
    },
  };
</script>

<style lang="less" scoped></style>
